<template>
    <Paginator
        @prev="pageNo--"
        :disable-prev="pageNo === 0"
        @next="pageNo++"
        :disable-next="nextDisabled">
        <div v-for="(importPatient, index) in getArrayPage(patients, pageNo)"
            :is="rowComponentType"
            :patient="importPatient"
            :key="index"
            :confirm="confirm"
            :index="pageNo * PerPageCount + index + 1"
            :same-schedule="sameSchedule"
            :column="column">
        </div>
    </Paginator>
</template>

<script>
import ImportRows from './row/components'
import Paginator from './row/Paginator'


/**
 * Renders rows in imports for patient events, profiles, etc
 * 
 * @component
 * @example
 * <PatientRows :patients="confirmedPatient"
 *    :column="column"
 *    row-component-type="PatientEvent">
 * </PatientRows>
 */
export default {
    name: 'patient-rows',

    props: {
        /**
         * The list of patient rows
         * to be render
         */
        patients: {
            type: Array,
            default: () => []
        },
        /**
         * Column matches in rows inputted
         * by excel
         */
        column: {
            type: Object,
            default: () => {}
        },
        /**
         * Type of component to be used
         * for rendering rows
         * @values PatientEmail, PatientEvent, PatientReschedule
         */
        rowComponentType: {
            type: String,
            default: 'PatientEmail',
            validator: (value) => ['PatientEmail', 'PatientEvent', 'PatientReschedule'].includes(value)
        },
        /**
         * Whether row is a same schedule
         * representation of events
         */
        sameSchedule: {
            type: Boolean,
            default: false
        },
        /**
         * Confirm some input from the user
         */
        confirm: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            /**
             * Current page no.
             */
            pageNo: 0,
            /**
             * Total count of Patient
             * in a single view
             */
            PerPageCount: 100
        }
    },

    methods: {
        /**
         * Get sliced array for input `pageNo`
         *
         * @param {[*]} arr Inputed array to slice
         * @param {Number} pageNo Page to be rendered
         */
        getArrayPage(arr, pageNo) {
            try {
                // Return array start of `pageNo * PerPageCount` to next `PerPageCount`
                return arr.slice(pageNo * this.PerPageCount, (pageNo + 1) * this.PerPageCount)
            } catch (error) {
                console.error('Error getting array paginated rows', error)
                return arr
            }
        }
    },

    computed: {
        /**
         * Check if next button should be disabled
         * 
         * @returns
         */
        nextDisabled() {
            try {
                return (this.pageNo + 1) * this.PerPageCount >= this.patients.length
            } catch (error) {
                console.error('Error in calculating nextDisabled', error)
                return false
            }
        }
    },

    components: {
        ...ImportRows,
        Paginator
    }
}
</script>
